import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import axios from "axios";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import StepLabel from "@mui/material/StepLabel";
import BasicInfo from "./steps/BasicInfo/BasicInfo";
import SelectPlan from "./steps/SelectPlan/SelectPlan";
import Settings from "./steps/Settings/Settings";
import { Provider, useDispatch, useSelector } from "react-redux";
import store from "../../MainWebsiteComponent/store";
import * as actions from "../../MainWebsiteComponent/store/actions";
import CustomizedSnackbar from "../../../hooks/Snackbar";
import { apiRequest } from "../../../utils/axiosInstance";

// import axios from "axios";

// development related
// import { sendDataToAPI, retriveDataFromAPI } from '../../../../hooks/HelperFunctions'

function getSteps() {
  return ["Basic info", "Settings"];
}

function CreateNewTeachingAccountSteps(props) {
  const router = useRouter();
  const [userData, setUserData] = useState({});
  const [invitationToken, setInviteToken] = useState("");
  const [errorChecking, setErrorChecking] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("error");
  const [userInfo, setUserInfo] = useState(null);

  const [available, setAvailable] = useState(false);
  //setup the baseurl
  const baseUrl =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [courseOverview, setCourseOverview] = useState({});
  const dispatch = useDispatch();
  let error = useSelector((state) => state.error);
  useEffect(() => {
    const userToken = localStorage.getItem("userToken");
    setUserData(JSON.parse(localStorage.getItem("userData")));
    setInviteToken(localStorage.getItem("invite_token"));

    axios
      .get(`${baseUrl}/getUserInfo`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((response) => {
        console.log(response?.data?.body);
        if (response?.data?.body) {
          setUserInfo(response?.data?.body);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const steps = getSteps();

  const data = {
    org_full_name: useSelector((state) => state.organizationName),
    firstName: useSelector((state) => state.firstName),
    lastName: useSelector((state) => state.lastName),
    dba: useSelector((state) => state.dba),
    street_address: useSelector((state) => state.streetAddress),
    city: useSelector((state) => state.city),
    state: useSelector((state) => state.state),
    zip_code: useSelector((state) => state.zipCode),
    country: useSelector((state) => state.country || "United States"),
    selected_package: useSelector((state) => state.packageType),
    payment_duration: useSelector((state) => state.paymentPeriod),
    teaching_page_url: useSelector((state) => state.teachingPageUrl),
    already_teaching: useSelector((state) => state.alreadyTeachingOnline),
    student_list_csv: useSelector((state) => state.studentsCSV),
    org_category: useSelector((state) => state.orgCategory),
    apt_no: useSelector((state) => state.apt),
    // full_name: useSelector((state) => state.fullName || "N/A"),
    teaching_as: useSelector((state) => state.teachingType),
    error: useSelector((state) => state.error),
    addressObj: useSelector((state) => state.addressObj),
    logged_in_email: userData?.email,
    invitation_token: invitationToken,
  };
  // const [addressType, setAddressType] = useState(() =>
  //   localStorage.getItem("addressType")
  // );
  // console.log(courseRelationalData.courseLanguages);
  const [checkingSubDomainError, setCheckingSubDomainError] = useState(false);
  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Provider store={store}>
            {" "}
            <BasicInfo userInfo={userInfo} />
          </Provider>
        );

      case 1:
        //provider wrapping settings component
        return (
          <Provider store={store}>
            <Settings
              checkingSubDomainError={checkingSubDomainError}
              setCheckingSubDomainError={setCheckingSubDomainError}
              available={available}
              setAvailable={setAvailable}
            />
          </Provider>
        );
      default:
        return "Unknown step";
    }
  };

  const isStepOptional = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const checkingSubDomain = async (subdomain) => {
    if (subdomain) {
      try {
        const data = await apiRequest(
          `/checkExistingSubDomain?searchText=${subdomain}`,
          "GET",
          null
        );

        return data?.status;
      } catch (error) {
        console.log(error);
        return true;
      }
    } else {
      return true;
    }
  };

  const handleNext = async () => {
    setErrorChecking(true);
    let getAddressItem = JSON.parse(localStorage.getItem("addressType"));
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === 0) {
      let errorCountForFirstStep = 0;
      const newErrors = { ...data.error };

      if (data.teaching_as === 1) {
        if (data.firstName === "" || data.firstName === undefined) {
          newErrors.firstName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.firstName = false;
        }
        if (data.lastName === "" || data.lastName === undefined) {
          newErrors.lastName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.lastName = false;
        }
      } else {
        if (data.org_full_name === "") {
          newErrors.organizationName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.organizationName = false;
        }
      }

      if (data.dba === "") {
        newErrors.dba = true;
        errorCountForFirstStep++;
      } else {
        newErrors.dba = false;
      }
      if (data.org_category === "" && data.teaching_as !== 1) {
        newErrors.orgCategory = true;
        errorCountForFirstStep++;
      } else {
        newErrors.orgCategory = false;
      }

      if (data.street_address === "" && !getAddressItem) {
        newErrors.streetAddress = true;
        errorCountForFirstStep++;
      } else {
        newErrors.streetAddress = false;
      }

      if (data.city === "" && !getAddressItem) {
        newErrors.city = true;
        errorCountForFirstStep++;
      } else {
        newErrors.city = false;
      }

      if (data.state === "" && !getAddressItem) {
        newErrors.state = true;
        errorCountForFirstStep++;
      } else {
        newErrors.state = false;
      }

      if (data.zip_code === "" && !getAddressItem) {
        newErrors.zipCode = true;
        errorCountForFirstStep++;
      } else {
        newErrors.zipCode = false;
      }

      if (data.addressObj === "" && getAddressItem) {
        newErrors.addressObj = true;
        errorCountForFirstStep++;
      } else {
        newErrors.addressObj = false;
      }
      dispatch(actions.setError(newErrors));
      if (errorCountForFirstStep > 0) {
        return;
      }
    } else if (activeStep === 1) {
      let errorCountForThirdStep = 0;
      const newErrors = { ...data.error };
      let exist = await checkingSubDomain(data.teaching_page_url);

      if (data.teaching_page_url === "") {
        newErrors.teachingPageUrl = true;
        errorCountForThirdStep++;
      } else if (checkingSubDomainError) {
        newErrors.teachingPageUrl = true;
        errorCountForThirdStep++;
      } else if (data.teaching_page_url.length < 3) {
        setAlertOpen(true);
        setAlertSeverity("error");
        setAlertMessage("The URL must be at least 3 characters in length.");
        errorCountForThirdStep++;
      } else if (exist) {
        setCheckingSubDomainError(true);
        setAvailable(false);
        return false;
      } else {
        newErrors.teachingPageUrl = false;
      }

      dispatch(actions.setError(newErrors));

      if (errorCountForThirdStep > 0) {
        return;
      }
    }
    setErrorChecking(false);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const saveData = async () => {
    //send the data to the api
    //call the api to save the data

    try {
      const response = await axios.post(
        `${baseUrl}/studentBecomeTeacher`,
        data
      );
      return response;
      //send the data to the api
    } catch (error) {
      console.error(error.message);
      return false;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (activeStep == steps.length) {
        console.log("last step");
        try {
          const getData = await saveData();

          if (getData) {
            router.push("/ta-pending-message");
          } else {
            setAlertOpen(true);
            setAlertSeverity("error");
            setAlertMessage(
              "We apologize for the inconvenience. There seems to be a temporary issue with our server. Please try again later."
            );
          }
        } catch (e) {
          console.error(e.message);
        }
      }
    };
    fetchData();
  }, [activeStep]);
  const alertCloseHandler = () => {
    setAlertOpen(false);
  };
  const handleStep = (step) => {
    if (step === 1) {
      let errorCountForFirstStep = 0;
      const newErrors = { ...data.error };

      if (data.teaching_as === 1) {
        if (data.firstName === "" || data.firstName === undefined) {
          newErrors.firstName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.firstName = false;
        }
        if (data.lastName === "" || data.lastName === undefined) {
          newErrors.lastName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.lastName = false;
        }
      } else {
        if (data.org_full_name === "") {
          newErrors.organizationName = true;
          errorCountForFirstStep++;
        } else {
          newErrors.organizationName = false;
        }
      }

      if (data.dba === "") {
        newErrors.dba = true;
        errorCountForFirstStep++;
      } else {
        newErrors.dba = false;
      }
      if (data.org_category === "" && data.teaching_as !== 1) {
        newErrors.orgCategory = true;
        errorCountForFirstStep++;
      } else {
        newErrors.orgCategory = false;
      }

      if (data.street_address === "" && !getAddressItem) {
        newErrors.streetAddress = true;
        errorCountForFirstStep++;
      } else {
        newErrors.streetAddress = false;
      }

      if (data.city === "" && !getAddressItem) {
        newErrors.city = true;
        errorCountForFirstStep++;
      } else {
        newErrors.city = false;
      }

      if (data.state === "" && !getAddressItem) {
        newErrors.state = true;
        errorCountForFirstStep++;
      } else {
        newErrors.state = false;
      }

      if (data.zip_code === "" && !getAddressItem) {
        newErrors.zipCode = true;
        errorCountForFirstStep++;
      } else {
        newErrors.zipCode = false;
      }

      if (data.addressObj === "" && getAddressItem) {
        newErrors.addressObj = true;
        errorCountForFirstStep++;
      } else {
        newErrors.addressObj = false;
      }
      dispatch(actions.setError(newErrors));
      if (errorCountForFirstStep > 0) {
        return;
      }
    }
    setActiveStep(step);
  };

  return (
    <div className="FormStepper">
      <CustomizedSnackbar
        open={alertOpen}
        message={alertMessage}
        severity={alertSeverity}
        closeHandler={alertCloseHandler}
      />
      <div className="StapperContaier">
        <div className="StapperBody">
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};

              if (isStepSkipped(index)) {
                stepProps.completed = false;
              }
              return (
                <Step key={label} {...stepProps}>
                  <StepLabel
                    {...labelProps}
                    onClick={() => handleStep(index)}
                    sx={{
                      cursor: "pointer",
                      "& .MuiStepLabel-label": {
                        "&:hover": {
                          textDecoration: "none",
                        },
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>

        <div className="StapperContent">
          {activeStep === steps.length ? (
            <div>
              <Typography>
                All steps completed - you&apos;re finished
              </Typography>
              <Button onClick={handleReset}>Reset</Button>
            </div>
          ) : (
            <div>
              <div>{getStepContent(activeStep)}</div>
              <div
                className="SpperButtonContainer"
                style={{ borderTop: "rgb(233 233 233) 1px solid" }}
              >
                <div className="StepperButton">
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    variant="outlined"
                    className="StepperBackButton"
                    sx={{
                      padding: "10px 20px !Important",
                      borderRadius: "10px !Important",
                      border: "1px solid #E4E8EC !Important",
                    }}
                  >
                    Cancel
                  </Button>
                  {/* {isStepOptional(activeStep) && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSkip}
                    // className="ButtonContinue"
                  >
                    Skip
                  </Button>
                )} */}

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className="ButtonContinue"
                  >
                    {activeStep === steps.length - 1 ? "Submit" : "Continue"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateNewTeachingAccountSteps;
